export { default, InlineConfig, TerseConfig } from "./Config";
